import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const getHolidays = createAsyncThunk(
  "holidays/getHolidays",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/holidays`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const holidaysSlice = createSlice({
  name: "holidays",

  initialState: {
    holidaysList: [],
    holidaysLoading: false,
    holidaysError: false,
    isCalendarOpen: false,
  },

  reducers: {
    toggleCalendar: (state, action) => {
      state.isCalendarOpen = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getHolidays.pending, (state) => {
        state.holidaysLoading = true;
        state.holidaysError = false;
      })
      .addCase(getHolidays.fulfilled, (state, action) => {
        state.holidaysLoading = false;
        state.holidaysError = false;
        state.holidaysList = action.payload;
      })
      .addCase(getHolidays.rejected, (state) => {
        state.holidaysLoading = false;
        state.holidaysError = true;
      });
  },
});

export const { toggleCalendar } = holidaysSlice.actions;
export default holidaysSlice.reducer;
